
export class OfflineService {

   imgLoad(imgJSON) {
    return new Promise(function (resolve, reject) {
      const request = new XMLHttpRequest();
      const filename = '/assets/images/Logo/' + imgJSON;
      request.open('Get', filename);
      request.responseType = 'blob';
      request.onload = function () {
        if (request.status === 200) {
          const arrayResponse = [];
          arrayResponse[0] = request.response;
          arrayResponse[1] = filename;
          resolve(arrayResponse);
        } else {
          reject(Error('Image did not found' + request.statusText));
        }
      };
      request.onerror = function () {
        reject(Error('Image did not found' + request.statusText));
      };
      request.send();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/offline.service.ts